import InventoryAdjustmentsReport from './components/InventoryAdjustmentReports/InventoryAdjustmentsReport';

// Add future reports here. Keep IDs stable because they are used in shared URLs.
export const reportDefinitions = [
    {
        id: 'inventory-adjustments',
        label: 'Inventory Adjustments',
        component: InventoryAdjustmentsReport,
    },
];
